import { validate } from 'gerador-validador-cpf';

export function cpf(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1-$2");
  return v.substring(0, 14);
}

export function rg(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/(\d{2})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1-$2");
  return v.substring(0, 14);
}

export function onlyNumber(v: string){
  return v.replace(/\D/g,"")
}

export function cellphone(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/^(\d\d)(\d)/g,"($1) $2");
  v=v.replace(/(\d{4})(\d{4})$/,"$1-$2");
  return v.substring(0, 15);
}

export function cep(v: string){
  v=v.replace(/D/g,"");
  v=v.replace(/^(\d{5})(\d)/,"$1-$2");
  return v;
}

export function validateCpf(strCpf: string){
  return validate(strCpf);
}

export function locationQuery() {
  return new URLSearchParams(window.location.search);
};

export function formatDate(v: string){
  if (v.match(/^\d{2}$/) !== null) {
    v = v + '/';
  } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
    v = v + '/';
  }
  return v.substring(0, 10);
}

export function validateEmail(email: string) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}
